export var validBreakpointValues = ["xs", "sm", "md", "lg", "xl", "xxl", "xxxl"];
export var validSpacingValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export var validBorderRadiusValues = ["none", "small", "standard", "full"];
export var validBoxShadowValues = ["none", "standard"];
export var breakpoints = {
  xs: 0,
  sm: 480,
  md: 640,
  lg: 800,
  xl: 960,
  xxl: 1200,
  xxxl: 1600
};
export var container = "1200px";
export var spacing = {
  0: "0",
  1: ".25rem",
  2: ".5rem",
  3: ".75rem",
  4: "1rem",
  5: "1.5rem",
  6: "2rem",
  7: "3rem",
  8: "4rem",
  9: "6rem",
  10: "8rem"
};
export var borderRadius = {
  none: "0",
  small: "2px",
  standard: "4px",
  full: "9999px"
};
export var boxShadow = {
  none: "none",
  standard: "hsla(0, 0%, 0%, .13) 0px 4px 8px 0px"
};
export default {
  breakpoints: breakpoints,
  container: container,
  spacing: spacing,
  borderRadius: borderRadius,
  boxShadow: boxShadow
};